const Product = ()=>{
    return <h1> Product </h1>
}
export default Product